import React, { useState } from "react";
import InputField from "../../CommonComponents/InputField";
import Button from "../../Button";
import IconButton from "../../CommonComponents/IconButton";

const EmbeddedLink = ({
  fieldName = "embeddedlinks",
  onChange = null,
  onAdd = null,
  links = [],
  onDelete = null,
  className = "",
}) => {
  const [value, setValue] = useState("");
  const [errors, setErrors] = useState({});

  const onChangeField = (field, value) => {
    setValue(value);
    onChange && onChange(field, value);
  };

  const onAddLink = () => {
    onAdd && onAdd(value);
    setValue("");
  };

  const onDeleteLink = (index) => {
    onDelete && onDelete(index);
  };

  return (
    <div className={`embedded-link-container ${className}`}>
      <div className="embedded-link-fields-wrapper">
        <InputField
          label="Embedded Links"
          name={fieldName}
          placeholder="Enter link"
          value={value}
          onChange={(event) =>
            onChangeField(event.target.name, event.target.value)
          }
          hintText={errors.name}
          destructive={!!errors.name}
        />
        <Button
          size="lg"
          hierarchy={{ type: "secondaryGrey", buttonText: "Link" }}
          destructive={false}
          className="embedded-link-add-btn"
          icon={{
            type: "leading",
            icon: (
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66927 0.834961V12.5016M0.835938 6.66829H12.5026"
                  stroke="#344054"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ),
          }}
          disable={value.length <= 5}
          onClick={onAddLink}
        />
      </div>
      {links.length >= 1 && (
        <>
          <p className="embedded-link-added-link-title">Added Links </p>
          {links.map((link, index) => (
            <div className="embedded-link-added-link-container" key={index}>
              <div className="embedded-link-added-link-wrapper">
                <InputField
                  name="embeddedlinks"
                  placeholder="Enter link"
                  value={link}
                  readOnly
                />
                <IconButton
                  size="md"
                  hierarchy="secondaryGrey"
                  destructive={true}
                  onClick={() => onDeleteLink(index)}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.5 4.99984H4.16667M4.16667 4.99984H17.5M4.16667 4.99984V16.6665C4.16667 17.1085 4.34226 17.5325 4.65482 17.845C4.96738 18.1576 5.39131 18.3332 5.83333 18.3332H14.1667C14.6087 18.3332 15.0326 18.1576 15.3452 17.845C15.6577 17.5325 15.8333 17.1085 15.8333 16.6665V4.99984H4.16667ZM6.66667 4.99984V3.33317C6.66667 2.89114 6.84226 2.46722 7.15482 2.15466C7.46738 1.8421 7.89131 1.6665 8.33333 1.6665H11.6667C12.1087 1.6665 12.5326 1.8421 12.8452 2.15466C13.1577 2.46722 13.3333 2.89114 13.3333 3.33317V4.99984M8.33333 9.1665V14.1665M11.6667 9.1665V14.1665"
                      stroke="#F04438"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </IconButton>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default EmbeddedLink;
